import React from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import * as Routes from '../../../../constants/routes';
import { trackingEvent } from '../../../../helpers/tracking';
import SummaryForm from '../../components/forms/assessment';
import InfoBox from '../../../../common/components/info-box';

const eventAction = 'Prosperity Planner - Assessment';

const trackingEmail = {
    eventAction,
    eventLabel: 'Email Results'
};
const trackingPrint = {
    eventAction,
    eventLabel: 'Print Results'
};
const trackingCoach = {
    eventAction,
    eventLabel: 'Contact a Libro Coach'
};

const slug = `${process.env.PUBLIC_URL}/prosperity-planner`;

const ctaButton = {
    link: `${slug}${Routes.CONTACTEMAIL}`,
    label: 'Email Results',
    onClick: () => trackingEvent(trackingEmail)
};

const printButton = {
    // eslint-disable-next-line
    link: 'javascript:window.print()',
    label: 'Print Results',
    onClick: () => trackingEvent(trackingPrint)
};

const tooltipButton = {
    link: `${slug}${Routes.CONTACTCOACH}`,
    label: 'Contact a Libro Coach',
    onClick: () => trackingEvent(trackingCoach)
};

const tooltip = {
    title: 'Looking for a professional opinion?',
    content: 'It helps to have a Coach and a few tools to make the journey that much more rewarding. Connect with a Libro Coach to find out how we can help.',
    button: tooltipButton
};

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Your Prosperity Plan</h1>
        <div className={styles.buttonContainer}>
            <Link
                to={ctaButton.link}
                onClick={ctaButton.onClick}
                className={styles.ctaButton}
                title={ctaButton.label}
            >
                {ctaButton.label}
            </Link>
            <a
                href={printButton.link}
                onClick={printButton.onClick}
                className={styles.ctaButton}
                title={printButton.label}
            >
                {printButton.label}
            </a>
        </div>
        <SummaryForm/>
        <InfoBox
            title={tooltip.title}
            content={tooltip.content}
            button={tooltip.button}
        />
    </div>
);
